import { Button, Col, Form, message, Modal, Row } from "antd";

import { option } from "../../Common/types";
import Dropdown from "../Dropdown/Dropdown";
import { TransferMachineApi } from "../../axios/portalData";
import { TransferMachineInput } from "../../Types/portalTypes";

import "./styles.less";
import GroupsMachinesReFetchFlagContext from "../../themeContext/GroupsMachinesReFetchFlagContext";
import { useContext } from "react";

interface Props {
  machines: option[];
  groups: string[];
  selectedGroupName: string;
  onClose: (refresh: boolean) => void;
}
const TransferMachine: React.FC<Props> = ({ machines, selectedGroupName, groups, onClose }) => {
  const { setGroupsMachinesReFetchFlag } = useContext(GroupsMachinesReFetchFlagContext);

  const onFinish = (values: Omit<TransferMachineInput, "source_group">) => {
    const input = values as TransferMachineInput;
    input["source_group"] = selectedGroupName;

    TransferMachineApi(input).then(function (response) {
      setGroupsMachinesReFetchFlag(true);
      message.success(response, 5);
      onClose(true);
    });
  };

  const selectedIndex = groups.indexOf(selectedGroupName);
  const groupOptions = [...groups];
  groupOptions.splice(selectedIndex, 1);

  return (
    <Modal
      centered={true}
      visible={true}
      footer={null}
      closable={false}
      wrapClassName="modal-wrapper"
      width={500}
      maskTransitionName=""
    >
      <Row>
        <Col span={24} className="transfer-machine-title">
          {`Transfer machine(s) from
          ${selectedGroupName}`}
        </Col>
        <Form
          name="basic"
          layout="horizontal"
          onFinish={onFinish}
          initialValues={{ machines: [] }}
          autoComplete="off"
          className="transfer-machine-form"
        >
          <Col lg={11} sm={24}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: " ",
                },
              ]}
              name="machines"
            >
              {/* OnChange and value are implicitly handled by the form */}
              <Dropdown
                title="Machines"
                options={machines}
                value={"this does nothing.Set by form initial values"}
                multiSelect={"multiple"}
                menuItemSelectedIcon={<></>}
                maxTagCount={1}
                mainClassName={"multi-select-option"}
              />
            </Form.Item>
          </Col>

          <Col lg={11} sm={24}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: " ",
                },
              ]}
              name="target_group"
            >
              {/* OnChange and value are implicitly handled by the form */}
              <Dropdown
                title="To"
                options={groupOptions.map((e) => ({ label: e, value: e }))}
                mainClassName={"group-dropdown-settings"}
                value={"this does nothing.Set by form initial values"}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item>
              <div className="btn-grp-wrapper">
                <Button className="primary-button" onClick={() => onClose(false)}>
                  Cancel
                </Button>
                <Button className="secondary-button" htmlType="submit">
                  Transfer
                </Button>
              </div>
            </Form.Item>
          </Col>
        </Form>
      </Row>
    </Modal>
  );
};

export default TransferMachine;
